import React from "react";
import { Modal } from "react-bootstrap";
import PerfectScrollbar from 'perfect-scrollbar';
import { wait, isMobile, isTablet, Event, __, hasClass, encode } from 'utils/Helper';
import C from 'utils/Constant';
import socket from "utils/Socket";
import Messages from "./Messages";
import Submit from "./Submit";
import Country from "./Country";
import Rain from "./Rain";
import Rules from "./Rules";
import { RxCross2 } from "react-icons/rx";


const chatSideBarWidth = 400;

class Chat extends React.Component {

    
    constructor(props,toggleModal) {
        super(props);
        this.state = {
            show: true
        };
    }

  

    componentDidMount() {
        if (isMobile() || isTablet()) {
            this.setState({ show: true });
        }
        window.addEventListener('resize', this.handleResize);

        wait(500)
            .then(() => {
                this.handleResize();
            });

        Event.on('toggle_sidebar', () => {
            wait(100)
                .then(() => {
                    this.handleResize();
                });
        })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const pageContent = document.querySelector('#page-content');
        const clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
        const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;

        if (pageContent !== null) {
            let space = 250;

            const leftSidebar = document.querySelector('.left-sidenav');
            const games = document.querySelectorAll('.game-image');

            if (hasClass(leftSidebar, 'min') || !this.state.show) {
                space -= 170;

                if (!isMobile()) {
                    games.forEach((g, i) => {
                        if (g !== null)
                            g.style.height = 160 + 'px';
                    })
                }
            }
            else {
                games.forEach((g, i) => {
                    if (g !== null)
                        g.style.height = 120 + 'px';
                })
            }

            let pWidth = this.state.show === true ? clientWidth - (chatSideBarWidth + space) : clientWidth;

            if (pWidth < 960) {
                Event.emit('hide_games');
            }
        }

        if (!isMobile()) {
            this.setState({ height: clientHeight - 230 });
        }
        else {
            this.setState({ height: clientHeight - 210 });
        }
    };

    setSide = () => {
        let show = !this.state.show;

        wait(1).then(() => {
            this.handleResize();
        });

        Event.emit('toggle_chat', show);

        wait(200).then(() => {
            this.setState({ show: show });
            if (this.props.toggleModal) {
                this.props.toggleModal(); // Call toggleModal if passed as a prop
            }
        });
    };

    render() {
        const { t } = this.props;
        let margin;
        if (isMobile())
            margin = 'mt-1'

        let status = 'left';
        if (this.state.show)
            status = 'right';

        return (
            <>
                {/* <button onClick={this.setSide} className={"btn rounded notif-btn tbtn btn-ocol px-1 py-1 " + margin}>
                    <i className={`mdi mdi-comment-arrow-${status} font-30`} />
                </button> */}

                {this.state.show && <Content t={t} height={this.state.height} setSide={this.setSide} />}
            </>
        );
    }
}

class Content extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: chatSideBarWidth + 'px',
            effect: "slideInRight"
        }
    }

    componentDidMount() {
        loadScroll();
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        Event.on('toggle_chat', (show) => {
            if (!show)
                this.setState({ effect: "slideOutRight" })
            else
                this.setState({ effect: "slideInRight" })
        })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        if (isMobile()) {
            this.setState({ width: '100%' })
        }
        else {
            this.setState({ width: chatSideBarWidth + 'px'})
        }
    };

    render() {
        const { t , setSide} = this.props;
        return (
            <>
                <div 
                    className={'main-menu-inner animated chat-body-bc ' + this.state.effect} 
                    style={{ 
                        zIndex: 9999, 
                        position: "fixed", 
                        top: 0, 
                        right: 0, 
                        height: "100vh", 
                        width: this.state.width, 
                        display: "flex", 
                        flexDirection: "column", 
                        backgroundColor: "#0f212e",
                        borderLeft: "1px solid rgba(255, 255, 255, 0.08)",
                        paddingBottom: isMobile() ? "65px" : "0px"
                    }}
                >
                    <div className="menu-body-chat" style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", overflow: "hidden" }}>
                        <div className="main-icon-menu-pane active" style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
                            <div className="title-box" style={{ backgroundColor: "#213743", borderBottom: "1px solid rgba(255,255,255,0.08)", padding: "10px 15px", flexShrink: 0 }}>
                                <h6 className="menu-title" style={{ textAlign: "center", alignItems: "center", display: "flex", height: "50px", justifyContent: "space-between", margin: 0 }}>
                                    <Country t={t}/>
                                    <div onClick={() => setSide()} className="chat-box-close-btn" style={{ display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #2f4553", backgroundColor: "#1a2c38", borderRadius: "5px", cursor: "pointer", width: "30px", height: "30px", marginRight: "10px" }}>
                                        <RxCross2 style={{ color: "#b1bad3", fontSize: "16px", cursor: "pointer", fontWeight: "900" }} />
                                    </div>
                                </h6>
                            </div>
                            <div id="messages" style={{ flex: 1, overflowY: "auto", backgroundColor: "#0f212e" }}>
                                <Messages t={t} />
                            </div>
                            <div style={{ flexShrink: 0 }}>
                                <Submit t={t} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

function loadScroll() {
    if (document.getElementById('messages') !== null) {
        let ps = new PerfectScrollbar('#messages', {
            wheelSpeed: 1,
            suppressScrollX: true,
            wheelPropagation: true,
            minScrollbarLength: 2
        });
        ps.update();
    }
}

export default Chat;
